export const SHARED_LINK_RESTORE_FAILED = 'SHARED_LINK_RESTORE_FAILED'
export const SHARED_LINK_RESTORE_NEEDS_REVIEW = 'SHARED_LINK_RESTORE_NEEDS_REVIEW'
export const DISMISS_SHARED_LINK_RESTORE_BANNER = 'DISMISS_SHARED_LINK_RESTORE_BANNER'

export enum SharedLinkRestoreStatus {
  NONE,
  RESTORE_FAILED,
  NEEDS_REVIEW
}

export type SharedLinkRestoreStatusAction = {
  type: typeof SHARED_LINK_RESTORE_FAILED
    | typeof SHARED_LINK_RESTORE_NEEDS_REVIEW
    | typeof DISMISS_SHARED_LINK_RESTORE_BANNER
}

export function sharedLinkRestoreFailed(): SharedLinkRestoreStatusAction {
  return {
    type: SHARED_LINK_RESTORE_FAILED
  }
}

export function sharedLinkRestoreNeedsReview(): SharedLinkRestoreStatusAction {
  return {
    type: SHARED_LINK_RESTORE_NEEDS_REVIEW
  }
}

export function dismissSharedLinkRestoreBanner(): SharedLinkRestoreStatusAction {
  return {
    type: DISMISS_SHARED_LINK_RESTORE_BANNER
  }
}
